import { useNavigate } from 'react-router';

import lang from '../../lib/language';

import arrowLeft from '../../assets/img/arrow-left.svg';
import ArrowBack from '../../assets/img/blue_icon-arrow-left.svg';
import { useIsMobile } from '../../hooks';
import { ClickableDiv } from '..';

import styles from './GoBackButton.module.scss';

type Props = {
  onBackBtnPress?: () => void;
};

const GoBackButton = ({ onBackBtnPress }: Props) => {
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();

  if (isMobile) {
    return (
      <button
        type="button"
        className={styles.returnBtn}
        onClick={() => (onBackBtnPress ? onBackBtnPress() : navigate(-1))}
      >
        <img src={ArrowBack} alt="Back" />
      </button>
    );
  }

  return (
    <div className={styles.backButtonWrapper}>
      <ClickableDiv
        className={styles.backButton}
        onClick={() => (onBackBtnPress ? onBackBtnPress() : navigate(-1))}
      >
        <img src={arrowLeft} alt={lang.commonGoBackBtn()} />
        <div className={styles.text}>{lang.commonGoBackBtn()}</div>
      </ClickableDiv>
    </div>
  );
};
export default GoBackButton;
